import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { UserRoutes } from "./routes.config";
import { AuthLayout } from "../layout/AuthLayout";
import { RootLayout } from "../layout/RootLayout";
import { LoginPage } from "../pages/LoginPage/LoginPage";
import { OnboardingPage } from "../pages/OnboardingPage/OnboardingPage";

export const AppRoutes = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route element={<RootLayout />}>
          {/* Public routes (no auth required) */}
          <Route path="/" element={<Navigate to="/devices" replace />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/onboarding" element={<OnboardingPage />} />

          {/* Authenticated routes */}
          <Route element={<AuthLayout />}>
            {UserRoutes.map((r) => (
              <Route key={r.path} path={r.path} element={r.element} />
            ))}
            <Route path="*" element={<h2>Not Found</h2>} />
          </Route>
        </Route>
      </Routes>
    </BrowserRouter>
  );
};
